import React from 'react';
import { observer } from 'mobx-react';
import { ListStore } from 'shared/stores/ListStore';
import { JobPositionStore } from 'ats/pages/job-positions/JobPositionStore';
import { JobPositionCard } from '../components/JobPositionCard';
import EmptyState from 'ats/components/empty-state/EmptyState';
import { EMPTY_STATE_ICONS } from 'ats/components/empty-state/emptyStateIcons';
import { modalStore } from 'components/layout/modals/ModalStore';
import { JobPositionCreate } from 'ats/pages/job-positions/components/JobPositionCreate';
import { Pagination } from 'ats/components/pagination/Pagination';

@observer
export class ClientJobPositions extends React.Component {
	constructor(props) {
		super(props);
		this.jobPositionStore = new JobPositionStore();
		this.listStore = new ListStore(this.jobPositionStore, {
			entityName: 'Job Position'
		});
	}

	preConfigureQuery() {
		this.listStore.loading = true;
		this.listStore.store.resetQuery();
		this.listStore.store.setQuery('clientId', this.props.client?.id);
		this.listStore.store.setQuery('sort', {
			column: 'createdAt',
			asc: false
		});
	}

	componentDidMount() {
		this.preConfigureQuery();
		if (this.props.client?.id) {
			this.listStore.search();
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.client !== this.props.client) {
			this.preConfigureQuery();
			this.listStore.search();
		}
	}

	handlePaginationChange = (page, limit) => {
		this.listStore.handlePaginationChange(page, limit);
	};

	handleCreateJobPosition = () => {
		const { client } = this.props;

		modalStore.openModal(
			{ title: 'Create Job Position', size: '2xl', position: 'center' },
			<JobPositionCreate
				clientId={client?.id}
				client={client ? { id: client.id, name: client.name } : null}
				handleSuccess={() => {
					this.props.onSuccess && this.props.onSuccess();
					this.listStore.search();
				}}
			/>
		);
	};

	render() {
		const hasJobPositions = this.listStore.data.length > 0;

		return (
			<div className="client-job-positions">
				<div className="client-tab-section-header">
					<div className="client-tab-section-title">Job Positions</div>
					<div className="table-action-buttons">
						<button
							type="button"
							className="ats-button-soft"
							onClick={this.handleCreateJobPosition}>
							Create Job
						</button>
					</div>
				</div>
				<div className="client-job-positions-body">
					{hasJobPositions ? (
						<>
							{this.listStore.data.map(jobPosition => (
								<JobPositionCard
									key={jobPosition.id}
									jobPosition={jobPosition}
									onSuccess={() => {
										this.props.onSuccess && this.props.onSuccess();
										this.listStore.search();
									}}
								/>
							))}
							<Pagination
								loading={this.listStore.loading}
								pagination={this.listStore.store.query.pagination}
								onPaginationChange={this.handlePaginationChange}
							/>
						</>
					) : !this.listStore.loading ? (
						<EmptyState
							icon={EMPTY_STATE_ICONS.job}
							iconAlt="No job positions"
							message="There are no job positions created for this client yet."
							actionText="Create Job Position"
							onActionClick={this.handleCreateJobPosition}
						/>
					) : null}
				</div>
			</div>
		);
	}
}
